const onload = require('window-load');
const WebVitalsTracker = require('./webVitals/webVitalsTracker');
const TrackingBeacon = require('./trackingBeacon');
const JSLoadTracker = require('./jsLoad/jsLoadTracker');

let tracker;
let jsLoadTracker;

function init(writeKey, tenant, culture) {
    if (typeof window === 'undefined' || !window.navigator) {
        return;
    }

    onload(() => {
        const tracking = new TrackingBeacon(writeKey, tenant, culture);
        tracker = new WebVitalsTracker(tracking);
        tracker.registerUnloadEvents();

        jsLoadTracker = new JSLoadTracker(tracking);
        jsLoadTracker.registerUnloadEvents();
    });
}

module.exports = {
    init: init
};
